<template>
  <div class="text-center">
    <div class="spinner-border spinner-border-sm" role="status"></div>
    <br v-if="twoLines" />
    <span v-else>&nbsp;&nbsp; </span>
    <span>{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "SpinnerLoader",
  props: {
    text: {
      type: String,
      default: "Cargando...",
    },
    twoLines: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
